<div class="webcam-wrapper" (click)="imageClick.next();">
  <video #video [width]="videoWidth" [height]="videoHeight" [class]="videoStyleClasses" autoplay muted playsinline (resize)="videoResize()"></video>
  <canvas #canvas [width]="width" [height]="height"></canvas>
</div>
